<template>
  <!-- Related Products -->
  <div
    v-if="relatedProducts !== null"
    class="related-products mt-5"
  >
    <b-container>
      <b-row>
        <b-col cols="12">
          <h2 class="text-center mb-4">Related Products</h2>
          <carousel
            :items="relatedProducts"
            :class="theme"
            :loading="false"
            :num-items="4"
            carousel-classes="products-carousel"
          >
            <template slot-scope="{ item }">
              <component
                :is="carouselItemLayout(item)"
                :item="item"
                :hover-card-enabled="hoverCardSetting"
              />
            </template>
          </carousel>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <!-- / Related Products -->
</template>

<script>
import Carousel from 'src/components/website/content-lists/content-creator-content/0001/displays/Carousel'

export default {
  name: 'product-details-page-related-products',
  components: {
    Carousel
  },
  props: {
    relatedProducts: {
      type: Array,
      required: true,
      default: () => { return [] }
    },
    theme: {
      type: String,
      required: false,
      default: () => { return '' }
    },
    hoverCardSetting: {
      type: Boolean,
      required: false,
      default: () => { return false }
    }
  },
  computed: {
    themeSettings() {
      return this.$store.state.registry.getModuleSetting('theme') || {}
    }
  },
  methods: {
    carouselItemLayout(item) {
      if (item.node_type) {
        const prefix = `${item.node_type.replace(/[_\s]/, '-')}-grid-item`
        const themeChoiceAvailable = (this.themeSettings !== null && Object.keys(this.themeSettings).includes('products') && this.themeSettings.products['catalogue-grid'])

        return (themeChoiceAvailable) ? `${this.themeSettings.products['catalogue-grid']}` : `${prefix}-0001`
      }

      return 'generic-product-grid-item'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep  .a-carousel.arrows-outside .swiper-arrow .icon-container svg path {
  fill: var(--vc-highlight-action-background-color) !important;
}
</style>
